import React from "react";
import { render } from "react-dom";
import { SnackbarProvider } from "notistack";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import LiffProvider from "providers/Liff";
import AuthProvider from "providers/Auth";
import ToastProvider from "providers/Toast";
import LoadingProvider from "providers/Loading";
import { liffId, stage } from "config/const";
import reportWebVitals from "./reportWebVitals";
import { COLOR } from "config/color";
import App from "./App";

import "./index.css";

const theme = createTheme({
  palette: {
    primary: {
      main: "#7b7c7e",
      contrastText: "#7b7c7e",
    },
    secondary: {
      main: "#fff",
      contrastText: "#7b7c7e",
    },
  },
  components: {
    MuiBackdrop: {
      styleOverrides: {
        root: {
          background: "rgba(256, 256, 256, 0.5)",
        },
      },
    },
    MuiModal: {
      styleOverrides: {
        root: {
          "&.black-mask": {
            background: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "initial",
          "&:hover": {
            opacity: "0.8",
          },
        },
      },
    },
    MuiCircularProgress: {
      styleOverrides: {
        root: {
          color: "black",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          fontSize: "1rem",
          margin: "0px",
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          background: COLOR.btnBackground,
          borderRadius: "10px",
          marginRight: "10px",
          padding: "5px",
          "&:hover": {
            background: COLOR.btnBackground,
          },
          "& svg": {
            fontSize: "2rem",
          },
        },
      },
    },
  },
  typography: {
    fontFamily: "LaPrairie-Light, '微軟正黑體', Arial, sans-serif",
    fontSize: 12,
    subtitle1: {
      fontSize: 14,
    },
    subtitle2: {
      fontSize: 18,
    },
    string: {
      fontSize: 14,
    },
    body1: {
      fontSize: "1.4rem",
      fontWeight: "normal",
      lineHeight: "160%",
      letterSpacing: "1px",
    },
    body2: {
      fontSize: "1rem",
      fontWeight: "normal",
      lineHeight: "160%",
      letterSpacing: "1px",
    },
  },
});
render(
  <LiffProvider
    liffId={liffId}
    mock={stage === "development" ? require("./config/mock").liff : undefined}
  >
    <SnackbarProvider maxSnack={3}>
      <ToastProvider>
        <AuthProvider>
          <ThemeProvider theme={theme}>
            <LoadingProvider>
              <App />
            </LoadingProvider>
          </ThemeProvider>
        </AuthProvider>
      </ToastProvider>
    </SnackbarProvider>
  </LiffProvider>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
